<template>
    <div v-if="!dataLoading">
        <b-row>
            <div class="col-12 mt-2">
                <b-form-group :label="$t('library_room_id')">
                    <LibraryRoomSelectbox :value="form.library_room_id" :disabled="true" />
                </b-form-group>
            </div>
            <div class="col-12 mt-2">
                <b-form-group :label="$t('name')">
                    <b-form-input :value="form.name" disabled></b-form-input>
                </b-form-group>
            </div>
            <div class="col-12 mt-2">
                <b-form-group :label="$t('status')">
                    <b-form-input :value="form.status === 'a' ? $t('active') : $t('passive')" disabled></b-form-input>
                </b-form-group>
            </div>
        </b-row>
    </div>
</template>

<script>
    import LibraryChairService from "@/services/LibraryChairService";
    import LibraryRoomSelectbox from "@/components/interactive-fields/LibraryRoomSelectbox";

    export default {
        components: {
            LibraryRoomSelectbox
        },
        props: {
            formId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                dataLoading: true,
                form: {}
            }
        },
        created() {
            this.loadData();
        },
        methods: {
            loadData() {
                LibraryChairService.get(this.formId)
                    .then(response => {
                        this.form = response.data.data;
                    })
                    .finally(() => {
                        this.dataLoading = false;
                    });
            }
        }
    }
</script>
